import { CreateCSSProperties } from "@material-ui/core/styles/withStyles";

export const pointer: CreateCSSProperties = {
  cursor: "pointer",
};

export const withOpacity = (value: number): CreateCSSProperties => ({
  opacity: value,
});
